import cn from 'classnames';
import { IconProps } from 'components/Shared/Icon/index';
import { iconStyles } from 'components/Shared/Icon/iconStyles';

export const IconHelpCenterOpt = (props: IconProps) => (
  <svg
    className={cn(iconStyles(props))}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="32.003"
    height="32"
    viewBox="0 0 32 32"
  >
    <g
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="2"
    >
      <path d="M15.056 18.584c-.55.054-1.111.082-1.681.082-1.695 0-3.311-.244-4.782-.685H8.59l-6.929 4.74 2.636-6.888v.002C2.251 14.26 1 12.15 1 9.833 1 4.955 6.541 1 13.375 1 20.21 1 25.75 4.955 25.75 9.833c0 1.537-.551 2.982-1.516 4.242" />
      <path d="m27.914 25.215.951 5.784-4.311-4.576.059-.01A10.15 10.15 0 0 1 23 26.54c-4.418 0-8-2.807-8-6.271 0-.732.161-1.438.457-2.09C16.555 15.744 19.517 14 23 14c.182 0 .363.005.543.014C27.707 14.232 31 16.95 31 20.27c0 2.011-1.207 3.801-3.086 4.949v-.004z" />
    </g>
  </svg>
);
